import { IUserGuiModel, IUserProfilePictureGuiModel, IUserProfileGuiData } from "../model/IUserGuiModel";
import UserService from "../service/UserService";
import { BusinessLogicDefaultResult, BusinessLogicResult } from "./BusinessLogicResult";
import { IUserModel, IUserProfilePictureModel} from "../service/model/IUserModel"; 
import { format } from "date-fns";

export default class UserBusinessLogic {

    private service: UserService;

    constructor() {
        this.service = new UserService();
    }

    public async putUserProfile(request: IUserGuiModel): Promise<BusinessLogicDefaultResult> {
        
        const userPutModel: IUserModel = {

            userId: request.userId ? { value: request.userId.value } : undefined,
            firstName: request.firstName ? { value: request.firstName.value } : undefined,
            lastName: request.lastName ? { value: request.lastName.value } : undefined,
            mobile: request.mobile ? { value: request.mobile.value } : undefined,
            phone: request.phone ? { value: request.phone.value } : undefined,
            title: request.title,
            dateOfBirth: request.dateOfBirth && request.dateOfBirth.value
                ? { value: format(new Date(request.dateOfBirth.value), "yyyy-MM-dd") }
                : { value: null },
        };

        const response = await this.service.modifyUserProfile(userPutModel);

        if (response.hasErrors) {
            return new BusinessLogicDefaultResult(response.errors);
        }

        return new BusinessLogicDefaultResult([]);
    }

    public async putUserProfilePicture(request: IUserProfilePictureGuiModel): Promise<BusinessLogicDefaultResult> {
        const profilePictureModel: IUserProfilePictureModel = {
            userId: request.userId,
            file: request.file,
        };

        const response = await this.service.updateUserProfilePicture(profilePictureModel);

        if (response.hasErrors) {
            return new BusinessLogicDefaultResult(response.errors);
        }

        return new BusinessLogicDefaultResult([]);
    }

    public async getProfilePictureFile(
        userId: string,
        width: number,
        height: number,

    ): Promise<BusinessLogicResult<Blob | undefined>> {

        const service = new UserService();

        const result = await service.getProfilePictureFile(
            userId,
            width,
            height
        );
        if (result.hasErrors) {
            return new BusinessLogicResult(undefined, result.errors);
        } else {
            return new BusinessLogicResult(result.value, result.errors);
        }
    };

    public async getProfileData(
        userId: string
    ): Promise<BusinessLogicResult<IUserProfileGuiData>> {
        const service = new UserService();
        const result = await service.getProfileData(userId);

        const e = result.value;

        const data: IUserProfileGuiData = {
            userId: e.userId,
            firstName: e.firstName || undefined,
            lastName: e.lastName || undefined,
            mobileNumber: e.mobileNumber || undefined,
            phoneNumber: e.phoneNumber || undefined,
            title: e.title || undefined,
            dateOfBirth: e.dateOfBirth ? format(new Date(e.dateOfBirth), "yyyy-MM-dd") : undefined,
            mobileCountryCode: e.mobileCountryCode || undefined,
            phoneCountryCode: e.phoneCountryCode || undefined,
        };

        return new BusinessLogicResult(data, result.errors);
    }
}